import Box from "@shared/components/ui-kit/layout/Box/Box.web";
import {
  consolidate,
  mergeMemberships,
} from "@shared/modules/basket/utils/helpers";
import CheckoutDeliverySingleOption from "@shared/modules/checkout/components/delivery-methods/CheckoutDeliverySingleOption/CheckoutDeliverySingleOption.web";
import { TicketItemGroupType } from "@shared/modules/item-groups/types/ticket-item-group-type";
import PublicCheckoutDeliveryItem from "../PublicCheckoutDeliveryItem/PublicCheckoutDeliveryItem.web";

function PublicCheckoutDeliverySingleOption({
  shippingTypePrintItemGroups,
  shippingTypeWillCallItemGroups,
  shippingTypeDeliveryItemGroups,
  allowQuantityChange = true,
}: {
  shippingTypePrintItemGroups: TicketItemGroupType[];
  shippingTypeWillCallItemGroups: TicketItemGroupType[];
  shippingTypeDeliveryItemGroups: TicketItemGroupType[];
  allowQuantityChange: boolean;
}) {
  return (
    <Box display="flex" flexDirection="column" gap="md">
      <CheckoutDeliverySingleOption
        itemGroups={consolidate(
          mergeMemberships([
            ...shippingTypePrintItemGroups,
            ...shippingTypeWillCallItemGroups,
            ...shippingTypeDeliveryItemGroups,
          ])
        )}
        renderDeliveryItem={(itemGroup) => {
          return (
            <PublicCheckoutDeliveryItem
              itemGroup={itemGroup}
              allowQuantityChange={allowQuantityChange}
            />
          );
        }}
      />
    </Box>
  );
}

export default PublicCheckoutDeliverySingleOption;
